import React from 'react';
import config from '../config';
import Chip from '@material-ui/core/Chip';
import { getLabel } from '../util';

const EntranceTypeField = ({ record = {}, source }) => (
        <Chip label={getLabel(record[source], config.entrance_types)} />
);

export default EntranceTypeField;